import { useEffect, useState } from 'react'

export function useInIframe() {
    const [inIframe, setInIframe] = useState(window.self !== window.top)

    useEffect(() => {
        setInIframe(window.self !== window.top)
    }, [])

    return inIframe
}
